import { render } from "./VisionProjects.vue?vue&type=template&id=1c698e8c"
import script from "./VisionProjects.vue?vue&type=script&lang=js"
export * from "./VisionProjects.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__